(() => {
  'use strict';

  function normalizeSelection(config, values) {
    const byId = new Map((config.choices || []).map(choice => [String(choice.id), choice]));
    const counts = new Map();
    const selection = [];
    if (!Array.isArray(values)) return selection;
    for (const value of values) {
      const id = String(value);
      const choice = byId.get(id);
      const count = counts.get(id) || 0;
      if (!choice?.available || choice.stock <= count || selection.length >= config.limit) continue;
      selection.push(id);
      counts.set(id, count + 1);
    }
    return selection;
  }

  function makePayload(config, values) {
    const selection = normalizeSelection(config, values);
    if (!config.available || config.stock < 1 || selection.length !== config.limit || selection.length !== values.length) return null;
    const byId = new Map(config.choices.map(choice => [String(choice.id), choice]));
    const quantities = new Map();
    selection.forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
    const names = [...quantities].map(([id, quantity]) => `${byId.get(id).title} (x${quantity})`).join(', ');
    return { id: String(config.id), quantity: 1, properties: { Products: names } };
  }

  if (typeof module === 'object' && module.exports) module.exports = { normalizeSelection, makePayload };
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const root = document.querySelector('[data-coffret-builder]');
  const config = window.MDM_COFFRET;
  if (!root || !config || !Array.isArray(config.choices)) return;
  const byId = new Map(config.choices.map(choice => [String(choice.id), choice]));
  const slots = document.querySelector('#coffret-slots');
  const count = document.querySelector('#coffret-count');
  const stickyCount = document.querySelector('#coffret-sticky-count');
  const progress = document.querySelector('.coffret-progress');
  const buy = document.querySelector('#coffret-add');
  const clear = document.querySelector('#coffret-clear');
  const availableFilter = document.querySelector('#coffret-only-available');
  const feedback = document.querySelector('#coffret-feedback');
  const storageKey = 'mirage-de-musc:coffret-draft:v1';
  let selected = [];
  let adding = false;
  try {
    const draft = JSON.parse(window.sessionStorage.getItem(storageKey));
    if (draft?.id === String(config.id)) selected = normalizeSelection(config, draft.selected);
  } catch (_) { /* Keep an editable selection when browser storage is unavailable. */ }

  function element(tag, className, text) {
    const item = document.createElement(tag);
    if (className) item.className = className;
    if (text !== undefined) item.textContent = text;
    return item;
  }
  function save() {
    try { window.sessionStorage.setItem(storageKey, JSON.stringify({ id: String(config.id), selected })); } catch (_) { /* The current selection remains usable. */ }
  }
  function render() {
    selected = normalizeSelection(config, selected);
    const total = selected.length;
    const message = `${total} / ${config.limit} muscs choisis`;
    count.textContent = message;
    stickyCount.textContent = message;
    progress.setAttribute('aria-valuenow', String(total));
    progress.setAttribute('aria-valuetext', message);
    progress.firstElementChild.style.width = `${total / config.limit * 100}%`;
    clear.hidden = total === 0;
    buy.disabled = adding || total !== config.limit || !config.available || config.stock < 1;
    buy.firstElementChild.textContent = adding ? 'Ajout du coffret…' : !config.available || config.stock < 1 ? 'Le coffret est indisponible' : total === config.limit ? 'Ajouter mon coffret au panier' : `Choisissez encore ${config.limit - total} musc${config.limit - total > 1 ? 's' : ''}`;

    root.querySelectorAll('.coffret-choice').forEach(card => {
      const id = card.dataset.choiceId;
      const choice = byId.get(id);
      const quantity = selected.filter(value => value === id).length;
      const initial = card.querySelector('[data-choice-add]');
      const controls = card.querySelector('.coffret-choice-controls');
      initial.hidden = quantity > 0;
      controls.hidden = quantity === 0;
      card.classList.toggle('is-chosen', quantity > 0);
      initial.disabled = !choice.available || choice.stock < 1 || total >= config.limit || adding;
      controls.querySelector('[data-choice-quantity]').textContent = String(quantity);
      controls.querySelector('[data-choice-step="1"]').disabled = quantity >= choice.stock || total >= config.limit || adding;
      controls.querySelector('[data-choice-step="-1"]').disabled = adding;
      card.hidden = availableFilter.checked && !choice.available;
    });
    document.querySelector('#coffret-empty').hidden = [...root.querySelectorAll('.coffret-choice')].some(card => !card.hidden);
    slots.replaceChildren();
    for (let index = 0; index < config.limit; index += 1) {
      const id = selected[index];
      const item = element('div', id ? 'coffret-slot selected' : 'coffret-slot');
      if (id) {
        const choice = byId.get(id);
        if (choice.image) {
          const image = element('img');
          image.src = choice.image;
          image.alt = choice.title;
          image.width = 70;
          image.height = 70;
          item.append(image);
        } else item.append(element('span', 'coffret-slot-number', String(index + 1).padStart(2, '0')));
        const text = element('span', 'coffret-slot-name', choice.label || choice.title);
        text.append(element('small', '', 'Musc · 20 ml'));
        item.append(text);
        const remove = element('button', 'coffret-slot-remove', '×');
        remove.type = 'button';
        remove.setAttribute('aria-label', `Retirer ${choice.label || choice.title} du coffret`);
        remove.disabled = adding;
        remove.addEventListener('click', () => {
          selected.splice(index, 1);
          feedback.textContent = '';
          save();
          render();
          const focusTarget = root.querySelector(`[data-choice-add="${id}"]:not([hidden])`) || root.querySelector(`.coffret-choice[data-choice-id="${id}"] [data-choice-step="-1"]`);
          focusTarget?.focus({ preventScroll: true });
        });
        item.append(remove);
      } else {
        item.append(element('span', 'coffret-slot-number', String(index + 1).padStart(2, '0')), element('span', 'coffret-slot-empty', 'Votre prochaine envie'));
      }
      slots.append(item);
    }
    document.dispatchEvent(new CustomEvent('mdm:coffret-change', { detail: { count: total, selectedIds: [...selected], payload: makePayload(config, selected) } }));
  }

  function change(id, step) {
    const choice = byId.get(id);
    if (!choice || adding) return;
    if (step > 0) {
      if (selected.length >= config.limit || !choice.available || selected.filter(value => value === id).length >= choice.stock) return;
      selected.push(id);
    } else {
      const index = selected.lastIndexOf(id);
      if (index < 0) return;
      selected.splice(index, 1);
    }
    feedback.textContent = '';
    save();
    render();
    const card = root.querySelector(`.coffret-choice[data-choice-id="${id}"]`);
    const active = selected.includes(id) ? card.querySelector(`[data-choice-step="${step}"]:not(:disabled)`) || card.querySelector('[data-choice-step="-1"]') : card.querySelector('[data-choice-add]');
    active?.focus({ preventScroll: true });
  }
  root.addEventListener('click', event => {
    const add = event.target.closest('[data-choice-add]');
    if (add) change(add.dataset.choiceAdd, 1);
    const step = event.target.closest('[data-choice-step]');
    if (step) change(step.dataset.choiceId, Number(step.dataset.choiceStep));
  });
  availableFilter.addEventListener('change', render);
  clear.addEventListener('click', () => {
    if (adding) return;
    selected = [];
    feedback.textContent = '';
    save();
    render();
    root.querySelector('.coffret-choice:not([hidden]) [data-choice-add]:not(:disabled)')?.focus({ preventScroll: true });
  });
  buy.addEventListener('click', async () => {
    const payload = makePayload(config, selected);
    if (!payload || adding) return;
    if (!window.MDMCart || typeof window.MDMCart.addConfigured !== 'function') {
      feedback.textContent = 'Votre composition est prête. L’ajout de ce coffret au panier sera disponible une fois la connexion à la boutique terminée.';
      feedback.focus?.({ preventScroll: true });
      return;
    }
    adding = true;
    feedback.textContent = '';
    render();
    try {
      const result = await window.MDMCart.addConfigured(payload);
      feedback.textContent = result === false ? 'Le coffret n’a pas pu être ajouté. Vérifiez sa disponibilité dans votre panier.' : 'Votre coffret a été ajouté avec les quatre muscs choisis.';
    } catch (_) {
      feedback.textContent = 'L’ajout n’a pas abouti. Votre composition est conservée ; vous pouvez réessayer.';
    } finally {
      adding = false;
      render();
    }
  });
  window.MDMCoffret = Object.freeze({ getPayload: () => makePayload(config, selected), getSelectedIds: () => [...selected] });
  render();
})();
